import React from 'react';
import { Col, Row } from 'antd';
import GalleryCard from 'components/GalleryCard';
import Section from 'components/Section';
import Content from 'layout/Basic/Content';
import Sider from 'layout/Basic/Sider';
import MainHitbox from './MainHitbox';

interface Props {
    galleries: Gallery[];
}

const GalleryHitbox = ({ galleries }: Props) => {
    return (
        <Row gutter={16}>
            <Content>
                <MainHitbox gallery={galleries[0]} />
            </Content>
            <Sider>
                <Section gutter={[16, 32]}>
                    <Col xs={12} md={24}>
                        <GalleryCard
                            title={galleries[1].title}
                            images={galleries[1].images}
                            slug={galleries[1].seoSlug}
                            category={galleries[1].category}
                        />
                    </Col>
                    <Col xs={12} md={24}>
                        <GalleryCard
                            title={galleries[2].title}
                            images={galleries[2].images}
                            slug={galleries[2].seoSlug}
                            category={galleries[2].category}
                        />
                    </Col>
                </Section>
            </Sider>
        </Row>
    );
};

export default GalleryHitbox;
